var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-root"},[(_vm.showMainContent)?_c('router-view'):(!_vm.isPreviewRoute)?_c('login',{on:{"login":function($event){return _vm.isLoggedIn()}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }